import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page partners-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "glass-card partners-intro" }
const _hoisted_6 = { class: "partners-desc" }
const _hoisted_7 = { class: "partners-grid" }
const _hoisted_8 = { class: "partner-slot-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eyebrowBusiness), 1),
      _createElementVNode("h1", {
        innerHTML: _ctx.jsonData.partners
      }, null, 8, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.jsonData.partnersIntro), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
        return _createElementVNode("div", {
          class: "partner-slot",
          key: i
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "partner-plus" }, "+", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.jsonData.partnerSlotLabel), 1)
        ])
      }), 64))
    ])
  ]))
}